import { createTheme } from '@mui/material';
import { palette } from './palette';
import { typography } from './typography';
import { createComponents } from './components';

const baseTheme = createTheme({
  palette,
  typography,
});

export const theme = createTheme({
  ...baseTheme,
  components: createComponents(baseTheme),
});
